import * as Dialog from "@radix-ui/react-dialog";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";

export interface MissingContactEmailDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onReportIssue: () => void;
}

export const MissingContactEmailDialog = ({
  open,
  onOpenChange,
  onReportIssue,
}: MissingContactEmailDialogProps) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 z-50" />
        <Dialog.Content className="fixed left-[50%] top-[50%] z-50 w-full max-w-[480px] max-h-[90vh] translate-x-[-50%] translate-y-[-50%] bg-white rounded-2xl shadow-lg overflow-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 focus:outline-none flex flex-col">
          <div className="relative p-6 pb-0">
            <div className="flex flex-col items-center text-center gap-y-2">
              <div className="bg-pale-mint-green rounded-full size-10 flex items-center justify-center mb-2">
                <img
                  src="/assets/icons/alert-fill.svg"
                  alt=""
                  className="size-6"
                  aria-hidden
                />
              </div>
              <Dialog.Title className="font-clash-display font-semibold text-[20px] text-[#121212] leading-normal">
                Contact email is missing
              </Dialog.Title>
              <Dialog.Description className="font-clash-display font-medium text-sm text-[#737373] leading-[20px]">
                We couldn't find a contact email on your PenCom records. You
                need a valid contact email to continue. Please report this
                issue so PenCom can update your company details.
              </Dialog.Description>
            </div>
            <Dialog.Close className="absolute top-6 right-6 rounded-sm opacity-70 hover:opacity-100 focus:outline-none transition-opacity cursor-pointer">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dialog.Close>
          </div>

          <div className="flex flex-col gap-3 p-6">
            <PrimaryButton
              className="w-full"
              title="Report issue to PenCom"
              onClick={onReportIssue}
            />
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className="w-full font-clash-display font-medium text-md text-medium-dark-grey hover:opacity-80 cursor-pointer py-2"
            >
              Cancel
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
